export default __webpack_public_path__ + "static/media/schulteletters_standard.6464f018.svg";